module.exports = __webpack_public_path__ + "static/zebraonesiehamper-39194e7cc6e26c0664b2bc077205b574.jpeg";